import { AxiosResponse } from "axios";
import { ICategoryItem } from "models";
import { API } from "utils/interceptor";

export const deleteCategoryApi = (
  id: string
): Promise<AxiosResponse<ICategoryItem>> => {
  return API.delete(`/category/${id}`);
};
